function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00877 0.0849609C4.12533 0.0849609 0.966187 3.24411 0.966187 7.12755C0.966187 11.011 4.12533 14.1701 8.00877 14.1701C11.8922 14.1701 15.0514 11.011 15.0514 7.12755C15.0514 3.24411 11.8922 0.0849609 8.00877 0.0849609ZM11.3581 10.7703C11.2437 10.8847 11.0934 10.9423 10.9432 10.9423C10.793 10.9423 10.6426 10.8847 10.5283 10.7703L7.59386 7.83593C7.4835 7.72621 7.42193 7.57706 7.42193 7.42102V3.60625C7.42193 3.28172 7.68478 3.01941 8.00877 3.01941C8.33277 3.01941 8.59562 3.28172 8.59562 3.60625V7.17805L11.3581 9.94045C11.5876 10.17 11.5876 10.5408 11.3581 10.7703Z"
});

var SvgTimeIcon = function SvgTimeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time-icon.511ec37b.svg";
export { ForwardRef as ReactComponent };